const queryFilterColors = [
	{ part: 1, color: 'red', themeColor: 'error-text-color' },
	{ part: 2, color: 'yellow', themeColor: 'warning-text-color' },
	{ part: 4, color: 'green', themeColor: 'success-text-color' },
];

export class QuickFilterController {
	static $inject = ['$scope', '$attrs', 'mx.app.ColorService', 'mx.app.ThemeService'];

	titles;
	colorized;
	colorService;
	themeService;
	isStatic;
	redTitle;
	yellowTitle;
	greenTitle;
	initState;
	onClick;

	constructor(scope, $attrs, colorService, themeService) {
		this.colorService = colorService;
		this.themeService = themeService;
		this.isStatic = $attrs.staticMode === 'true';

		scope.$watch((this.isStatic ? '::' : '') + 'vm.value', (value) => {
			value = +value;
			this.red = this.colorized || value & 1;
			this.yellow = this.colorized || value & 2;
			this.green = this.colorized || value & 4;

			this.lastClick = value;
		});
	}

	$onInit() {
		this.lastClick = +this.initState || 0;

		if (!this.isStatic) {
			this.themeService.getCurrentTheme().then((theme) => {
				const bgColor = theme?.['content-bg-color'];
				queryFilterColors.forEach((f) => {
					const filterColor = theme?.[f.themeColor];
					this[`opacity_${f.color}`] = filterColor && bgColor && this.colorService.getContrastDelta(bgColor, filterColor) < 0.2 ? 0.8 : 0.6;
				});
			});
		}

		if (this.titles) {
			try {
				const titles = JSON.parse(this.titles);
				this.redTitle = titles.red;
				this.yellowTitle = titles.yellow;
				this.greenTitle = titles.green;
			} catch (e) {
				mx.logCatch(e);
			}
		}

		this.parts = isFinite(this.parts) ? +this.parts : 7;
	}

	click(value) {
		this.lastClick = this.lastClick ^ value;
		this.onClick({ color: this.lastClick });
	}

	showPart(value) {
		return this.parts & value;
	}

	isActivated(value) {
		return this.lastClick & value;
	}
}

angular.module('mx.components').component('mxQuickFilter', {
	scope: {},
	bindings: {
		value: '@',
		parts: '@',
		titles: '@',
		onClick: '&',
		initState: '@',
		colorized: '<',
	},

	template: [
		'$attrs',
		function ($attrs) {
			const isStatic = $attrs.staticMode === 'true';
			const optimizer = isStatic ? '::' : '';

			const filters = queryFilterColors
				.map((f) => {
					let ngClickAttribute = '';
					let style = '';
					if (!isStatic) {
						ngClickAttribute = ` ng-click="vm.click(${f.part})"`;
						style = ` style="--mx-quick-filter-opacity: {{ vm.opacity_${f.color}}}"`;
					}

					return (
						'<div' +
						` ng-show="${optimizer}vm.showPart(${f.part})"` +
						' class="mx-quick-filter_item"' +
						` ng-class="${optimizer}{ 'mx-quick-filter_${f.color}':vm.${f.color}, 'mx-quick-filter_activated':vm.isActivated(${f.part}) }"` +
						` title="{{:: vm.${f.color}Title}}"` +
						' tabindex="-1"' +
						style +
						ngClickAttribute +
						'>' +
						`{{${optimizer} vm.isActivated(${f.part}) ? '&bull;' : '' }} ` +
						'</div>'
					);
				})
				.join('');

			return `<div class="mx-quick-filter layout-row layout-align-center-center">${filters}</div>`;
		},
	],

	controller: QuickFilterController,
	controllerAs: 'vm',
});
